import { Navigate, useLocation } from 'react-router-dom';
import useCheckAuth from '../hooks/auth/useCheckAuth.js';
import ROUTES from '../routes/Routes.js';

const ProtectedRoute = ({ component: Component, requiredRole }) => {
    const { isAuthenticated, user, loading } = useCheckAuth();
    const location = useLocation();
  
    if (loading) {
        return null;  // No renderizar nada mientras se verifica la autenticación
    }
  
    if (!isAuthenticated) {
        // Guarda la ruta actual en state para redirigir después del login
        return <Navigate to={ROUTES.LOGIN} state={{ from: location }} />;
    }

    if (requiredRole && String(user.roleid) !== String(requiredRole)) {
        return <Navigate to={ROUTES.UNAUTHORIZED} />;  // Redirige a una página de acceso no autorizado
    }

    return <Component />;
};

export default ProtectedRoute;